//export const ApiEndpoint = "https://mbsms.ihct.mx/";
//export const ApiEndpoint = "http://67.208.218.152:3009/";
export const ApiEndpoint =
  process.env.API_ENDPOINT || "https://qa-sms.odt.com.mx/api/";
//export const ApiEndpoint = "http://127.0.0.1:3001/";
export const ShortUrlEndpoint =
  process.env.SHORT_URL_ENDPOINT || "https://odt.mx/";
//export const ApiSMSEndpoint = "http://localhost:5000/sendsms";
export const ApiSMSEndpoint =
  process.env.API_SMS_ENDPOINT || "https://smsapi.odt.com.mx/sendsms";

export const ApiRCSEndpoint =
  process.env.API_RCS_ENDPOINT || "https://smsapi.odt.com.mx/sendrcs";

// export const FILES_SERVICE_URL = process.env.NODE_ENV === "development"
//   ? "http://localhost:4000/files-service/files"
//   : "https://qa-sms.odt.com.mx/filesserver/files-service/files";

export const FILES_SERVICE_URL =
  "https://sms.odt.com.mx/filesserver/files-service/files";
